import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { ButtonWithIcon } from '@els/els-react--button';

function DocumentAbstract({ abstractText, closeClick }) {
  return (
    <div className="result-detail-panel u-els-margin-top-1o2">
      <div className="result-detail-panel-wrapper u-els-padding">
        <div className="result-detail-panel-header">
          <h4 className="u-els-margin-bottom-1o2">Abstract</h4>
          <ButtonWithIcon
            type="link"
            iconOnly
            sprite="Close"
            className="sub-menu-close e2e-close"
            data-automationid="sub-menu-close"
            onClick={closeClick}>
            close
          </ButtonWithIcon>
        </div>
        <InnerHTML
          tag="p"
          className="result-detail-block u-els-font-size-caption u-els-line-height-default u-els-margin-top-1o2"
          html={abstractText}
        />
      </div>
    </div>
  );
}

DocumentAbstract.propTypes = {
  abstractText: PropTypes.string.isRequired,
  closeClick: PropTypes.func.isRequired,
};

export default DocumentAbstract;
